export const CommissionTypes = {
  Ladder: 'ladder',
  Parent: 'parent',
  Regular: 'regular',
  Child: 'child',
} as const;
